import { apiFetch } from "./apiFetch";

export function fetchTodayCheckin() {
  return apiFetch("/checkins/today/");
}

export function createCheckin(payload) {
  return apiFetch("/checkins/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function fetchRecentCheckins() {
  return apiFetch("/checkins/recent/");
}

export function fetchCheckinStreak() {
  return apiFetch("/checkins/streak/");
}

export function createPresenceCheckin() {
  return apiFetch("/checkins/presence/", {
    method: "POST",
  });
}
